var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
import { __awaiter, __decorate, __metadata } from "tslib";
import { Mutation, Action, VuexModule, Module } from 'vuex-module-decorators';
import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/finance/DirectorateEnums';
let DirectorateModule = class DirectorateModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.wasFirstLoad = true;
        this.loading = false;
        this.loadPage = false;
        this.directorateList = [];
        this.page = 1;
        this.size = 10;
        this.pageFilter = 1;
        this.wasLoadQuickFilter = true;
        this.desc = '';
        this.searchBy = '';
        this.paging = [];
        this.status = '';
        this.statusMessage = '';
        this.selectedDirectorateName = [];
        this.dropdownlistDirectorateCode = [];
        this.dropdownlistDirectorateName = [];
    }
    get getDirectorateWasFirstLoad() {
        return this.wasFirstLoad;
    }
    get getDropdownlistDirectorateCode() {
        return this.dropdownlistDirectorateCode;
    }
    get getDropdownlistDirectorateName() {
        return this.dropdownlistDirectorateName;
    }
    get getDirectorateLists() {
        return this.directorateList;
    }
    get getDirectorateStatus() {
        const status = {
            status: this.status,
            statusMessage: this.statusMessage
        };
        return status;
    }
    get getSelectedDirectorateName() {
        return this.selectedDirectorateName;
    }
    get getDirectoratePaging() {
        return this.paging;
    }
    get getDirectorateLoading() {
        return this.loading;
    }
    get getStatusDirectorate() {
        const status = {
            status: this.status,
            statusMessage: this.statusMessage
        };
        return status;
    }
    get getDirectorateSize() {
        return this.size;
    }
    get getDirectorateWasLoadQuickFilter() {
        return this.wasLoadQuickFilter;
    }
    get getDirectorateDesc() {
        return this.desc;
    }
    get getDirectorateSearchBy() {
        return this.searchBy;
    }
    [_a = Mutations.SET_DIRECTORATE_LOAD](payload) {
        this.wasFirstLoad = payload;
    }
    [_b = Mutations.SET_SELECTED_DIRECTORATE_NAME](payload) {
        this.selectedDirectorateName = payload;
    }
    [_c = Mutations.SET_DIRECTORATE_LIST](payload) {
        this.directorateList = payload;
    }
    [_d = Mutations.SET_DIRECTORATE_LOADING](payload) {
        this.loading = payload;
    }
    [_e = Mutations.SET_DIRECTORATE_HANDLE_PAGE](payload) {
        this.page = payload;
    }
    [_f = Mutations.SET_DIRECTORATE_PAGE](payload) {
        this.paging = payload;
    }
    [_g = Mutations.SET_DIRECTORATE_LOAD_PAGE]() {
        this.loadPage = true;
    }
    [_h = Mutations.SET_DIRECTORATE_STATUS](payload) {
        this.status = payload.statusAssetNumber;
        this.statusMessage = payload.statusMessageAssetNumber;
    }
    [_j = Mutations.SET_DROPDOWNLIST_DIRECTORATE_CODE](payload) {
        this.dropdownlistDirectorateCode = payload;
    }
    [_k = Mutations.SET_DROPDOWNLIST_DIRECTORATE_NAME](payload) {
        this.dropdownlistDirectorateName = payload;
    }
    [_l = Mutations.SET_DIRECTORATE_SIZE](payload) {
        this.size = payload;
    }
    [_m = Mutations.SET_DIRECTORATE_HANDLE_SIZE](payload) {
        this.size = payload;
    }
    [_o = Mutations.SET_DIRECTORATE_PAGE_FILTER](payload) {
        this.pageFilter = payload;
    }
    [_p = Mutations.SET_DIRECTORATE_WAS_LOAD_QUICK_FILTER](payload) {
        this.wasLoadQuickFilter = payload;
    }
    [_q = Mutations.SET_DIRECTORATE_DESC](payload) {
        this.desc = payload;
    }
    [_r = Mutations.SET_DIRECTORATE_SEARCH_BY](payload) {
        this.searchBy = payload;
    }
    [_s = Actions.GET_DIRECTORATE_LIST]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_DIRECTORATE_LOADING, false);
            const params = {
                ver: 'v1'
            };
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/directorate/filter?` +
                new URLSearchParams(params).toString();
            const paramsData = {
                Page: this.page.toString(),
                Size: this.size.toString(),
                directorateName: this.selectedDirectorateName,
                isActive: true
            };
            return new Promise((resolve, reject) => {
                ApiService.post(url, paramsData)
                    .then((res) => {
                    var _y, _z;
                    if (res.status === 200) {
                        this.context.commit(Mutations.SET_DIRECTORATE_LIST, ((_y = res.data.result.content) === null || _y === void 0 ? void 0 : _y.data) || []);
                        this.context.commit(Mutations.SET_DIRECTORATE_LOAD_PAGE, true);
                        this.context.commit(Mutations.SET_DIRECTORATE_PAGE, ((_z = res.data.result.content) === null || _z === void 0 ? void 0 : _z.paging) || {
                            currentPage: 0,
                            totalPages: 0,
                            totalElements: 0,
                            errorRows: 0,
                            readyToUpload: 0
                        });
                        this.context.commit(Mutations.SET_DIRECTORATE_LOADING, false);
                        resolve(true);
                    }
                    else {
                        this.context.commit(Mutations.SET_DIRECTORATE_LOADING, false);
                        reject(false);
                    }
                })
                    .catch((err) => {
                    reject(false);
                });
            });
        });
    }
    [_t = Actions.GET_DIRECTORATE_LIST_ALLDATA]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_DIRECTORATE_WAS_LOAD_QUICK_FILTER, false);
            const params = {
                ver: 'v1'
            };
            const dataListDirectorateCode = [...this.dropdownlistDirectorateCode];
            const dataListDirectorateName = [...this.dropdownlistDirectorateName];
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/directorate/filter?` +
                new URLSearchParams(params).toString();
            const paramsData = {
                Page: this.pageFilter.toString(),
                Size: '10',
                Desc: this.desc,
                SearchBy: this.searchBy,
                isActive: true
            };
            return new Promise((resolve, reject) => {
                ApiService.post(url, paramsData)
                    .then((res) => {
                    if (res.status === 200) {
                        if (res.data.result.content !== null) {
                            if (res.data.result.content.paging.totalPages === this.pageFilter) {
                                this.context.commit(Mutations.SET_DIRECTORATE_WAS_LOAD_QUICK_FILTER, false);
                            }
                            else {
                                this.context.commit(Mutations.SET_DIRECTORATE_WAS_LOAD_QUICK_FILTER, true);
                            }
                            res.data.result.content.data.map((data) => {
                                dataListDirectorateCode.push({
                                    value: data.directorateCode,
                                    label: data.directorateCode
                                });
                            });
                            res.data.result.content.data.map((data) => {
                                dataListDirectorateName.push({
                                    value: data.directorateName,
                                    label: data.directorateName
                                });
                            });
                        }
                        else {
                            this.context.commit(Mutations.SET_DIRECTORATE_WAS_LOAD_QUICK_FILTER, false);
                        }
                        this.context.commit(Mutations.SET_DROPDOWNLIST_DIRECTORATE_CODE, dataListDirectorateCode);
                        this.context.commit(Mutations.SET_DROPDOWNLIST_DIRECTORATE_NAME, dataListDirectorateName);
                        resolve(true);
                    }
                    else {
                        this.context.commit(Mutations.SET_DIRECTORATE_WAS_LOAD_QUICK_FILTER, false);
                        reject(false);
                    }
                })
                    .catch((err) => {
                    this.context.commit(Mutations.SET_DIRECTORATE_WAS_LOAD_QUICK_FILTER, false);
                    reject(false);
                });
            });
        });
    }
    [_u = Actions.UPDATE_DIRECTORATE_SIZE](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_DIRECTORATE_SIZE, data);
            this.context.commit(Mutations.SET_DIRECTORATE_HANDLE_PAGE, 1);
            this.context.dispatch(Actions.GET_DIRECTORATE_LIST);
        });
    }
    [_v = Actions.UPDATE_DIRECTORATE_PAGE_FILTER]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_DIRECTORATE_PAGE_FILTER, this.pageFilter + 1);
        });
    }
    [_w = Actions.UPDATE_DIRECTORATE_CODE](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_DIRECTORATE_SEARCH_BY, data === '' ? '' : 'directoratecode');
            this.context.commit(Mutations.SET_DIRECTORATE_DESC, data);
            this.context.commit(Mutations.SET_DROPDOWNLIST_DIRECTORATE_CODE, []);
            this.context.commit(Mutations.SET_DROPDOWNLIST_DIRECTORATE_NAME, []);
            this.context.commit(Mutations.SET_DIRECTORATE_PAGE_FILTER, 1);
            this.context.dispatch(Actions.GET_DIRECTORATE_LIST_ALLDATA);
        });
    }
    [_x = Actions.UPDATE_DIRECTORATE_DESC](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_DIRECTORATE_SEARCH_BY, data === '' ? '' : 'directoratename');
            this.context.commit(Mutations.SET_DIRECTORATE_DESC, data);
            this.context.commit(Mutations.SET_DROPDOWNLIST_DIRECTORATE_CODE, []);
            this.context.commit(Mutations.SET_DROPDOWNLIST_DIRECTORATE_NAME, []);
            this.context.commit(Mutations.SET_DIRECTORATE_PAGE_FILTER, 1);
            this.context.dispatch(Actions.GET_DIRECTORATE_LIST_ALLDATA);
        });
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DirectorateModule.prototype, _a, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DirectorateModule.prototype, _b, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DirectorateModule.prototype, _c, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DirectorateModule.prototype, _d, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DirectorateModule.prototype, _e, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DirectorateModule.prototype, _f, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DirectorateModule.prototype, _g, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DirectorateModule.prototype, _h, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DirectorateModule.prototype, _j, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DirectorateModule.prototype, _k, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DirectorateModule.prototype, _l, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DirectorateModule.prototype, _m, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DirectorateModule.prototype, _o, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DirectorateModule.prototype, _p, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DirectorateModule.prototype, _q, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DirectorateModule.prototype, _r, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], DirectorateModule.prototype, _s, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], DirectorateModule.prototype, _t, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], DirectorateModule.prototype, _u, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], DirectorateModule.prototype, _v, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], DirectorateModule.prototype, _w, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], DirectorateModule.prototype, _x, null);
DirectorateModule = __decorate([
    Module
], DirectorateModule);
export default DirectorateModule;
